import { Link } from "react-router-dom";

export const Logo = ({ testid = "site-logo", className = "" }) => (
  <Link to="/" data-testid={testid} className={`group flex items-center gap-4 ${className}`} aria-label="Ramor Renewables home">
    <span className="block">
      <img src="/img/ramor-logo.png" alt="Ramor Renewables" className="h-8 w-auto sm:h-9" />
    </span>
    <span className="label-mono hidden leading-tight text-steel xl:block">
      Mechanical &amp;<br />Renewable Contractors
    </span>
  </Link>
);
